import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import fp from 'lodash/fp';
import { connect } from 'react-redux';
import { pattern, mapState } from '@deerplusofficial/pos-helper';
import { withClient } from '@deerplusofficial/pos-hoc';
import { Button } from '@deerplusofficial/pos-components';
import { Form, Dimmer } from '../../components';
import SidebarContent from './SidebarContent';
import Profile from './Profile';
import Slogan from './Slogan';
import FormField from './FormField';

const Hero = Slogan.extend`
  text-align: center;
`;

class LoginForm extends Component {
  static propTypes = {
    channel: PropTypes.shape(),
  };

  static defaultProps = {
    channel: {},
  };

  state = {
    email: '',
    password: '',
    error: {},
    authFail: false,
    submitting: false,
  };

  onFieldChange = ({ name, value }) => this.setState({ [name]: value });

  onSubmit = async e => {
    e.preventDefault();

    const {
      client: { onLogin },
    } = this.props;
    const { email, password } = this.state;
    const error = {
      email: !pattern.email.test(email) && '請輸入正確的 email 格式',
      password: !pattern.password.test(password) && '密碼格式是8-64個英數字元',
    };

    if (error.email || error.password) return this.setState({ error });

    this.setState({ error: {}, submitting: true });

    const payload = await onLogin({ email, password });

    if (payload && payload.status === 'error')
      return this.setState({ authFail: true, submitting: false });

    this.setState({ submitting: false });
  };

  render() {
    const { channel } = this.props;
    const { email, password, error, authFail, submitting } = this.state;

    return (
      <SidebarContent>
        {_.size(channel) > 0 ? (
          <React.Fragment>
            <Hero>
              <Profile
                lead
                companyName={channel.name}
                companyPhotoUrl={channel.logo}
              />
              您正要登入店面 POS 系統
            </Hero>
            <Form onSubmit={this.onSubmit}>
              <FormField
                type="text"
                name="email"
                label="請登入您的 STAFF 帳號"
                placeholder="輸入 Email"
                value={email}
                error={error.email}
                onChange={this.onFieldChange}
              />
              <FormField
                autoComplete="on"
                type="password"
                name="password"
                label="密碼"
                placeholder="輸入密碼"
                value={password}
                error={error.password}
                onChange={this.onFieldChange}
              />
              <Form.Actions>
                {authFail && <Form.Alert>您的密碼或帳號輸入錯誤</Form.Alert>}
                <Button ghost type="submit" loading={submitting}>
                  登入
                </Button>
                <Button link color="white">
                  忘記密碼？
                </Button>
              </Form.Actions>
            </Form>
          </React.Fragment>
        ) : (
          <Dimmer />
        )}
      </SidebarContent>
    );
  }
}

export default fp.compose(
  withClient(),
  connect(mapState(['channel']))
)(LoginForm);



// WEBPACK FOOTER //
// ./src/pages/Login/LoginForm.js